import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../styles/camry-package-item.css";
import img02 from "../assets/all-images/cars-img/bmw-offer.png";

const Gmc = () => {
  return (
    <section>
      <Container>
        <Row>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Jeddah Airport to Makkah Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 350.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent ">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Jeddah Airport to Makkah Hotel using GMC?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Madina Airport to Madina Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 200.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Madina Airport to Madina Hotel using GMC?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Makkah Hotel to Madina Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 700.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Makkah Hotel to Madina Hotel? using GMC"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Jeddah Airport To Madina Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 800.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Jeddah Airport To Madina Hotel using GMC?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">Makkah Ziyarat</h5>
                <h6 className="rent__price text-center mt-">
                  SAR 250.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Makkah Ziyarat using GMC?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">Madina Ziyarat</h5>
                <h6 className="rent__price text-center mt-">
                  SAR 200.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Madina Ziyarat using GMC?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Makkah To Taif Ziyarat And Return
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 600.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Makkah To Taif Ziyarat And Return using GMC?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Makkah Hotel To Jeddah Airport
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 300.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Makkah Hotel To Jeddah Airport using GMC?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Madina Hotel To Madina Airport
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 150.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Madina Hotel To Madina Airport using GMC?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Madina Hotel To Makkah Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 800.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Madina Hotel To Makkah Hotel using GMC?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>

          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Madina Hotel To Jeddah Airport
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 800.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Madina Hotel To Jeddah Airport using GMC?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>

          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Jeddah To Taif Ziyarat And Return
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 950.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Jeddah To Taif Ziyarat And Return using GMC?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5">
            <div className="camry-package__item">
              <div className="camry-package__img--gmc">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">GMC</h2>
                <h5 className="section__title text-center">
                  Jeddah Airport To Jeddah Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 200.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Jeddah Airport To Jeddah Hotel using GMC?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Gmc;
